import React from 'react'

const Footer = () => {
	return (
		<div className="footer">
			<div className="copyrighttext">
				&copy; 2020 Quiz Center
				&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
				All Rights Reserved
			</div>
		</div>
	)
}

export default Footer
